export default "__VITE_ASSET__CEafU3n6__"